export default function ShareETA() {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>Share ETA</h1>
    </div>
  );
}